// @flow
import React from 'react';
import { Button } from '../../common';
import bigBackground from '../../../src/static/images/banner.png';

type Props = {
  channel: string,
  setChannel: (c: string) => void,
  onSubmit: (e: SyntheticEvent<>) => void,
  verifying: boolean,
};

const VerifyMfaChannelStep = ({ channel, setChannel, onSubmit, verifying }: Props) => (
  <div className="login-page">
    <div className="login-page-image-panel">
      <img src={bigBackground} alt="Big Delivery" className="login-page-image" />
    </div>
    <div className="login-page-form-panel">
      <h2 className="login-page-title">Verificar conta</h2>
      <p className="login-page-subtitle">
        Por onde você gostaria de receber o código de verificação?
      </p>
      <div className="login-box-main login-box-fade-in">
        <form onSubmit={onSubmit}>
          <div className="mfa-channel-options">
            <select
              className="mfa-form-select-dropdown"
              value={channel}
              onChange={e => setChannel(e.target.value)}
            >
              <option value="email">Email</option>
              <option value="sms">SMS</option>
            </select>
          </div>
          <Button
            text="Continuar"
            icon=""
            buttonType="button-secondary"
            loading={verifying}
            disabled={verifying}
          />
        </form>
      </div>
    </div>
  </div>
);

export default VerifyMfaChannelStep;
